// Defined in general.js
/* global dcLocalStorage */

import { extractElementsAtIndices, randomIndices } from './arrayUtils.js';


const SHUFFLE_STORAGE_NAME = 'searchShuffle';

/**
 * Randomly selects some search results out of a set. We store which elements were extracted
 * so the results will be consistent when a user refreshes the page.
 * @param results {T[]} List of search results (e.g. projects or essentials lists)
 * @param max {number} The max number of results to extract
 * @returns {T[]} A list of max randomized search results
 */
export default function (results, max = results.length) {
    // Store different randomizations for different result sizes
    const key = `${SHUFFLE_STORAGE_NAME}-${results.length}-${max}`;
    let indices = dcLocalStorage.getValue(key);

    if (!indices) {
        indices = randomIndices(results, max);
        dcLocalStorage.setValue(key, indices);
    }

    return extractElementsAtIndices(results, indices);
}
